import Layout from "@/layout";

export default {
  path: "/fuel-card",
  component: Layout,
  meta: {title: "Fuel Card", icon: ""},
  name: "FuelCard",
  hidden: true,
  children: [
    {path: "*"},
  ]
}
